import template from './related-list-field.html';
import controller from './related-list-field-controller';

const RelatedListFieldComponent = {
    bindings: {
        displayProp: '<',
        itemList: '<',
        itemsPerPage: '<',
        customOrdering: '<',
        relatedModelList: '<',
        relatedModelName: '<',
        updateItemList: '&'
    },
    controller,
    template
};

export default RelatedListFieldComponent;



// WEBPACK FOOTER //
// ./app/common/form-fields/related-list-field/related-list-field-component.js